import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NoTrailingSlashUrlSerializer implements UrlSerializer {
  private defaultSerializer = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    return this.defaultSerializer.parse(url);
  }

  serialize(tree: UrlTree): string {
    let url = this.defaultSerializer.serialize(tree);

    // Separa fragmento (#) si existe
    const [pathAndQuery, fragment] = url.split('#');
    // Separa query params (?) si existen
    const [path, query] = pathAndQuery.split('?');

    // Agrega slash al final del path si falta
    let normalizedPath = path;
    if (!normalizedPath.endsWith('/')) {
      normalizedPath += '/';
    }

    // Reconstruye la URL con query y fragment
    let finalUrl = normalizedPath;
    if (query) finalUrl += `?${query}`;
    if (fragment) finalUrl += `#${fragment}`;

    return finalUrl;
  }
}